"use client";

import React, { useState, useRef, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { BASE_URL, IMG_URL } from "../../AdminComponent/BaseUrl";
import { useDispatch } from "react-redux";
import { addToWishList } from "../../Store/WishList/wishlist-actions";
import addToCart from "../../Utils/AddtoCart";
import custdecryptedUserId from "../../Utils/CustUserid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../AdminComponent/Loader";
import useBreadcrumb from "../../Utils/Breadcrum";
import Cookies from "js-cookie";
import LoginForm from "../Authentication/LoginForm";
import { Swiper, SwiperSlide } from "swiper/react";
import { Zoom, Mousewheel, Navigation, Thumbs } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "../../tailwind.css";
import "../../App.css";
import "../../Style.css";
import { pushEvent } from "../../Utils/dataLayer";

const ProductDetailLuxury = () => {
  const { productslug } = useParams();
  const dispatch = useDispatch();
  
  // State management - matching exact structure from reference
  const [selectedImage, setSelectedImage] = useState(0);
  const [selectedColor, setSelectedColor] = useState(0);
  const [selectedSize, setSelectedSize] = useState(1);
  
  // Swiper-specific states
  const [activeIndex, setActiveIndex] = useState(0);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const [showStickyBar, setShowStickyBar] = useState(false);
  const [isPriceRequestOpen, setIsPriceRequestOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const [activeTab, setActiveTab] = useState('specification');
  
  // API data states
  const [productdata, setProductdata] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const [colorImages, setColorImages] = useState([]);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [reserveStock, setReserveStock] = useState(0);
  const [seoData, setSeoData] = useState({});
  const [selectedColorId, setSelectedColorId] = useState(null);
  
  // Price request form
  const [priceRequestForm, setPriceRequestForm] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
    pincode: "",
    state: "",
    country: "",
    remarks: "",
  });

  // Carousel states for related products
  const [relatedProductsIndex, setRelatedProductsIndex] = useState(0);

  // Refs
  const heroRef = useRef(null);
  const breaddata = useBreadcrumb(4);

  // Swiper handlers
  const handleSlideClick = (index) => {
    setActiveIndex(index);
    setSelectedImage(index);
    
    localStorage.setItem("initial", index);
    
    if (swiperInstance) {
      swiperInstance.slideTo(index);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      localStorage.removeItem("initial");
    }, 2000);
  }, []);

  // Responsive hook
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // API Functions
  const getProductDetails = async () => {
    setLoader(true);
    try {
      const response = await axios.post(`${BASE_URL}/getproductDetails`, {
        productslug: productslug,
      });
      
      if (response.data.data && response.data.data.length > 0) {
        setProductdata(response.data.data);
        setReserveStock(response.data.r_stock);
        
        const product = response.data.data[0];
        getProductImages(product.id);
        getRelatedProducts(product.catid, product.id);
      }
    } catch (error) {
      console.error('Error fetching product details:', error);
    } finally {
      setLoader(false);
    }
  };

  const getProductImages = async (productId) => {
    try {
      const response = await axios.post(`${BASE_URL}/product_img_data`, {
        product_id: productId,
      });
      
      if (response.data && response.data.length > 0) {
        setProductImages(response.data);
        setColorImages(response.data[0].images || []);
        setSelectedColorId(response.data[0].id);
      }
    } catch (error) {
      console.error('Error fetching product images:', error);
    }
  };

  const getColorImages = async (colorId) => {
    setLoader(true);
    setSelectedColorId(colorId);
    try {
      const response = await axios.post(`${BASE_URL}/getcolorimg`, {
        colorid: colorId,
      });
      
      if (response.data && response.data.length > 0) {
        setColorImages(response.data[0].images || []);
        setSelectedImage(0); // Reset to first image
        setActiveIndex(0); // Reset Swiper activeIndex when color changes
        
        // Reset main swiper to first slide
        if (swiperInstance) {
          swiperInstance.slideTo(0);
        }
      }
    } catch (error) {
      console.error('Error fetching color images:', error);
    } finally {
      setLoader(false);
    }
  };

  const getRelatedProducts = async (catId, productId) => {
    try {
      const response = await axios.post(`${BASE_URL}/getrelatedproduct`, {
        catid: catId,
        product_id: productId,
      });
      setRelatedProducts(response.data || []);
    } catch (error) {
      console.error('Error fetching related products:', error);
    }
  };

  const getSeoData = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/getmetadetail`, {
        page_id: 4,
      });
      if (response.data && response.data.length > 0) {
        setSeoData(response.data[0]);
      }
    } catch (error) {
      console.error('Error fetching SEO data:', error);
    }
  };



  const sendInquiry = async (productId) => {
    try {
      // const inquiryData = {
      //   inquiry: priceRequestForm.remarks,
      //   product_id: productId,
      //   email: localStorage.getItem("ecom_email"),
      //   mobile: localStorage.getItem("ecom_mobile"),
      //   user_id: custdecryptedUserId(),
      //   name: localStorage.getItem("Name") + " " + localStorage.getItem("lastname"),
      // };

      // Removed: await axios.post(`${BASE_URL}/sendinquiry`, inquiryData);

      // Send email to admin
      await axios.post(`${BASE_URL}/api/send-price-request-email`, {
        name: priceRequestForm.name,
        phone: priceRequestForm.phone,
        email: priceRequestForm.email,
        city: priceRequestForm.city,
        pincode: priceRequestForm.pincode,
        state: priceRequestForm.state,
        country: priceRequestForm.country,
        remarks: priceRequestForm.remarks,
        productName: productdata[0]?.title || "Unknown Product",
        productUrl: window.location.href
      });

      toast.success("Request submitted successfully!");
      setIsPriceRequestOpen(false);
      setPriceRequestForm({
        name: "",
        phone: "",
        email: "",
        city: "",
        pincode: "",
        state: "",
        country: "",
        remarks: "",
      });
    } catch (error) {
      console.error('Error sending inquiry:', error);
      toast.error("Failed to send inquiry. Please try again.");
    }
  };

  // Utility function for Indian number formatting
  const formatIndianPrice = (price) => {
    if (!price) return '0';
    const num = parseFloat(price);
    return num.toLocaleString('en-IN');
  };

  // Event handlers
  const handleAddToCart = (product) => {
    if (!product) return;
    
    addToCart(
      product.id,
      product.title,
      product.catid,
      product.disc_price,
      dispatch,
      quantity,
      product.v_id,
      product.gst
    );
    toast.success(`${quantity} item(s) added to cart!`, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const incrementQuantity = () => {
    setQuantity(prev => prev + 1);
  };

  const decrementQuantity = () => {
    setQuantity(prev => prev > 1 ? prev - 1 : 1);
  };

  // Login modal toggle
  const handleToggle = () => {
    setOpen(!open);
  };

  // Wishlist functions - matching DetailPage exactly
  const wishify = () => toast("Product added to the wishlist");

  const addWishList = (productId) => {
    const id = productId;
    const userId = custdecryptedUserId();
    const wishData = {
      id,
      userId,
    };

    dispatch(addToWishList(wishData));
  };

  const handlePriceRequestSubmit = (e) => {
    e.preventDefault();
    if (productdata.length > 0) {
      sendInquiry(productdata[0].id);
    }
  };

  const handlePriceRequestChange = (e) => {
    const { name, value } = e.target;
    setPriceRequestForm(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  // Scroll effect for sticky bar
  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const heroHeight = heroRef.current.offsetHeight;
        setShowStickyBar(window.scrollY > heroHeight);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Initial data loading
  useEffect(() => {
    getProductDetails();
    getSeoData();
  }, [productslug]);



  // Set document title
  useEffect(() => {
    if (productdata.length > 0 || seoData.seo_title) {
      document.title = seoData.seo_title || productdata[0].title || "Product Details";
    }
  }, [productdata, seoData]);

  // Track view_item event when product data is loaded
  useEffect(() => {
    if (productdata && productdata.length > 0) {
      const product = productdata[0];
      pushEvent('view_item', {
        currency: 'INR',
        value: parseFloat(product.disc_price || product.price),
        items: [{
          product_id: product.id,
          item_name: product.title,
          item_category: product.category,
          price: parseFloat(product.disc_price || product.price),
          quantity: 1
        }]
      });
    }
  }, [productdata]);

  if (loader) {
    return <Loader />;
  }

  if (!productdata.length) {
    return <div className="loading">Loading...</div>;
  }

  const product = productdata[0];

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {/* Breadcrumb Banner - Exact DetailPage Style with proper wrapper */}
      <div id="site-main" className="site-main" style={{ marginBottom: '0px' }}>
        <div
          id="title"
          className="page-title"
          style={{
            backgroundImage: `url('${IMG_URL}/Breadcrumbs/${breaddata}')`,
            height: 'calc(50% - 8px)',
            minHeight: 'calc(100px - 8px)'
          }}
        >
          <div className="section-container">
            <div className="content-title-heading"></div>
            <div className="breadcrumbs">
              <Link to="/">Home</Link>
              <span className="delimiter"></span>
              <Link to="/shoproduct">Shop</Link>
              <span className="delimiter"></span>
              {product.title}
            </div>
          </div>
        </div>
      </div>
      
      <div className="relative" style={{ marginTop: '-50px', paddingTop: '0px' }}>
        {/* Head elements moved to document head via useEffect */}
        <section
          ref={heroRef}
          className="relative w-full overflow-hidden bg-gradient-to-b from-stone-100 to-white dark:from-stone-900 dark:to-stone-950"
          style={{ paddingTop: '0px', marginTop: '0px' }}
        >

          <div className="mx-auto max-w-7xl px-4 pt-8" style={{ marginTop: '50px' }}>
            <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:gap-20">
              {/* Left Side - Swiper Image Gallery */}
              <div className="relative">
                <div className="flex items-center gap-6">
                  {/* Thumbnail Swiper - Vertical (Desktop) */}
                  <div className="hidden md:flex">
                    <div className="content-thumbnail-scroll">
                      <div className="image-thumbnail slick-vertical">
                        <Swiper
                          spaceBetween={isMobile ? 1 : 0}
                          slidesPerView={3}
                          modules={[Mousewheel, Navigation, Thumbs]}
                          direction={isMobile ? "horizontal" : "vertical"}
                          mousewheel
                          watchSlidesProgress={true}
                          onSwiper={setThumbsSwiper}
                        >
                          {colorImages.map((image, index) => (
                            <SwiperSlide key={index}>
                              <div
                                className={`img-item slick-slide cursor-pointer overflow-hidden rounded-md border-2 transition-all duration-300 hover:scale-110 ${
                                  activeIndex === index ? "border-amber-600 dark:border-amber-400 shadow-lg" : "border-transparent"
                                }`}
                                onClick={() => handleSlideClick(index)}
                              >
                                <span className="img-thumbnail-scroll block h-16 w-16">
                                  <img
                                    width="64"
                                    height="64"
                                    src={`${IMG_URL}/productimg/${image}`}
                                    alt={`${product.title} - View ${index + 1}`}
                                    className="h-full w-full object-cover"
                                  />
                                </span>
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    </div>
                  </div>

                  {/* Main Image Swiper */}
                  <div className="relative aspect-square flex-1 overflow-hidden rounded-lg bg-white dark:bg-stone-800 shadow-xl">
                    <div className="scroll-image main-image">
                      <div className="image-additional">
                        <Swiper
                          initialSlide={activeIndex || localStorage.getItem("initial")}
                          onSlideChange={(swiper) => {
                            setActiveIndex(swiper.activeIndex);
                            setSelectedImage(swiper.activeIndex);
                          }}
                          navigation
                          thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                          modules={[Mousewheel, Navigation, Thumbs, Zoom]}
                          onSwiper={(swiper) => setSwiperInstance(swiper)}
                          zoom={{
                            maxRatio: 2,
                            minRatio: 1,
                          }}
                          className="h-full w-full"
                        >
                          {colorImages.map((image, index) => (
                            <SwiperSlide key={index}>
                              <div className="swiper-zoom-container">
                                <img
                                  src={`${IMG_URL}/productimg/${image}`}
                                  alt={`${product.title} - View ${index + 1}`}
                                  className="h-full w-full object-cover transition-transform duration-300"
                                />
                              </div>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile Thumbnail Swiper - Horizontal */}
                <div className="mt-4 md:hidden">
                  <Swiper
                    spaceBetween={8}
                    slidesPerView={4}
                    modules={[Navigation]}
                    navigation
                    watchSlidesProgress={true}
                    className="mobile-thumbnail-swiper"
                  >
                    {colorImages.map((image, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className={`relative h-16 w-16 cursor-pointer overflow-hidden rounded-md border-2 transition-all duration-300 ${
                            activeIndex === index ? "border-amber-600 dark:border-amber-400" : "border-transparent"
                          }`}
                          onClick={() => handleSlideClick(index)}
                        >
                          <img
                            src={`${IMG_URL}/productimg/${image}`}
                            alt={`${product.title} - View ${index + 1}`}
                            className="h-full w-full object-cover"
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>

              {/* Right Side - Product Info */}
              <div className="relative">
                <div className="sticky top-8">
                  {/* Product Tags */}
                  <div className="mb-4 flex space-x-2">
                    {product.isluxe?.toUpperCase() === 'YES' && (
                      <div className="inline-block rounded-full bg-gradient-to-r from-amber-600 to-amber-800 px-3 py-1 text-sm uppercase tracking-wider text-white shadow-lg">
                        LUXE
                      </div>
                    )}
                    {product.customizable == 1 && (
                      <div className="inline-block rounded-full bg-gradient-to-r from-black to-gray-700 px-3 py-1 text-sm uppercase tracking-wider text-white shadow-lg">
                        Customisable
                      </div>
                    )}
                  </div>

                  {/* Product Name */}
                  <h1 className="font-serif text-3xl font-light tracking-tight md:text-3xl lg:text-5xl dark:text-white">
                    {product.title}
                  </h1>

                  {/* Price */}
                  <div className="mt-4 flex items-baseline">
                    <span className="text-2xl font-light md:text-3xl dark:text-white">₹{formatIndianPrice(product.disc_price)}</span>
                    {product.price && (
                      <span className="ml-2 text-lg text-stone-500 line-through dark:text-stone-400">
                        ₹{formatIndianPrice(product.price)}
                      </span>
                    )}
                  </div>

                  {/* Stock Status */}
                  <div className="mt-4">
                    {product.stock > 0 && product.stock !== reserveStock ? (
                      <div className="inline-flex items-center rounded-full bg-emerald-100 px-3 py-1 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-100">
                        <svg className="mr-1 h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                        In Stock
                      </div>
                    ) : (
                      <div className="inline-block rounded-full bg-red-100 px-3 py-1 text-red-800 dark:bg-red-900 dark:text-red-100">
                        Out of Stock
                      </div>
                    )}
                  </div>

                  {/* Color Selection */}
                  {productImages.length > 0 && (
                    <div className="mt-8">
                      <h3 className="mb-3 text-sm font-medium uppercase tracking-wider dark:text-white">Color</h3>
                      <div className="flex space-x-3">
                        {productImages.map((item, index) => (
                          <button
                            key={index}
                            className={`group relative h-12 w-12 rounded-full border-2 transition-all duration-300 hover:scale-110 ${
                              selectedColorId === item.id ? "border-amber-600 dark:border-amber-400" : "border-transparent"
                            }`}
                            onClick={() => getColorImages(item.id)}
                          >
                            <span 
                              className="absolute inset-1 rounded-full" 
                              style={{ backgroundColor: item.colorcode }}
                            />
                            <span className="absolute -bottom-7 left-1/2 -translate-x-1/2 whitespace-nowrap text-xs opacity-0 transition-opacity group-hover:opacity-100 dark:text-white">
                              {item.colorname || `Color ${index + 1}`}
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Size Selection */}
                  {(product.length || product.breadth || product.height) && (
                    <div className="mt-8">
                      <h3 className="mb-3 text-sm font-medium uppercase tracking-wider dark:text-white">Size</h3>
                      <div className="flex flex-wrap gap-3">
                        <button className="rounded-full border border-amber-600 bg-amber-600 px-6 py-2 text-sm text-white transition-all duration-300 hover:scale-105 dark:border-amber-500 dark:bg-amber-500">
                          {product.length} × {product.breadth} × {product.height} {product.lbh_unit}
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Quantity and Add to Cart */}
                  <div className="mt-8">
                    <div className="flex items-center gap-3">
                      {/* Quantity Counter */}
                      <div className="flex items-center rounded-full border border-amber-700 bg-white dark:border-amber-500 dark:bg-stone-800">
                        <button
                          className="flex h-12 w-12 items-center justify-center rounded-l-full text-amber-700 transition-colors hover:bg-amber-50 dark:text-amber-500 dark:hover:bg-amber-950/50"
                          onClick={decrementQuantity}
                        >
                          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                          </svg>
                        </button>
                        <span className="flex h-12 w-16 items-center justify-center text-center font-medium dark:text-white">
                          {quantity}
                        </span>
                        <button
                          className="flex h-12 w-12 items-center justify-center rounded-r-full text-amber-700 transition-colors hover:bg-amber-50 dark:text-amber-500 dark:hover:bg-amber-950/50"
                          onClick={incrementQuantity}
                        >
                          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                          </svg>
                        </button>
                      </div>

                      {/* Add to Cart Button */}
                      <button
                        className="flex-1 rounded-full bg-amber-700 py-3 text-base text-white transition-all duration-300 hover:bg-amber-800 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-amber-600 dark:hover:bg-amber-700"
                        disabled={product.stock <= 0 || product.stock === reserveStock}
                        onClick={() => handleAddToCart(product)}
                      >
                        {product.stock > 0 && product.stock !== reserveStock ? "Add to Cart" : "Notify Me When Available"}
                      </button>
                    </div>

                    {/* Price on Request Button */}
                    {product.customizable == 1 && (
                      <button
                        className="mt-4 w-full rounded-full border border-amber-700 bg-amber-700 py-6 text-base text-white transition-all duration-300 hover:bg-amber-800 hover:text-white dark:border-amber-500 dark:bg-amber-500 dark:text-white dark:hover:bg-amber-600 dark:hover:text-white"
                        onClick={() => setIsPriceRequestOpen(true)}
                      >
                        Price on Request
                      </button>
                    )}
                  </div>

                  {/* Wishlist - matching DetailPage exactly */}
                  <div className="mt-4">
                    {!Cookies.get('custuserid') ? (
                      <button
                        className="flex items-center text-sm text-stone-600 transition-colors hover:text-amber-700 dark:text-stone-300 dark:hover:text-amber-400"
                        onClick={() => handleToggle()}
                      >
                        <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                        Add to Wishlist
                      </button>
                    ) : (
                      <button
                        className="flex items-center text-sm text-stone-600 transition-colors hover:text-amber-700 dark:text-stone-300 dark:hover:text-amber-400"
                        onClick={() => {
                          addWishList(product.id);
                          wishify();
                        }}
                      >
                        <svg className="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                        Add to Wishlist
                      </button>
                    )}
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Product Description - Magazine Style */}
        <section className="bg-white dark:bg-stone-950" style={{ paddingTop: '10px', marginTop: '100px', paddingBottom: '100px' }}>
          <div className="mx-auto max-w-3xl px-4 text-center">
            <h2 className="mb-2 font-serif text-3xl font-light md:text-4xl dark:text-white">The Story</h2>

            {/* Pull Quote */}
            <blockquote className="my-6 font-serif text-2xl italic leading-relaxed text-amber-800 md:text-3xl dark:text-amber-300">
              "Where profuse luxury meets curvaceous indulgence."
            </blockquote>

            {/* Description Paragraphs */}
            <div className="space-y-8 text-left text-lg leading-relaxed dark:text-stone-300">
              <p>{product.description}</p>
            </div>
          </div>
        </section>

        {/* Specifications & Profile Tabs */}
        <section className="bg-stone-50 py-8 dark:bg-stone-900">
          <div className="mx-auto max-w-3xl px-4">
            <h2 className="mb-4 text-center font-serif text-3xl font-light md:text-4xl dark:text-white">
              Product Details
            </h2>

            {/* Tab Navigation */}
            <div className="mb-4 flex justify-center">
              <div className="relative flex items-center rounded-full bg-white p-1 shadow-sm dark:bg-stone-800">
                {/* Sliding background */}
                <div
                  className={`absolute top-1 bottom-1 rounded-full bg-amber-700/90 transition-all duration-300 ease-in-out dark:bg-amber-600/90 ${
                    activeTab === 'specification' ? 'left-1 w-[calc(50%-4px)]' : 'left-[calc(50%+2px)] w-[calc(50%-4px)]'
                  }`}
                />
                
                <button
                  className={`relative z-10 flex h-12 items-center justify-center px-12 text-sm font-medium leading-none transition-all duration-300 ${
                    activeTab === 'specification'
                      ? 'text-white'
                      : 'text-black hover:text-amber-700 dark:text-white dark:hover:text-amber-400'
                  }`}
                  onClick={() => setActiveTab('specification')}
                >
                  Specifications
                </button>
                <button
                  className={`relative z-10 flex h-12 items-center justify-center px-16 text-sm font-medium leading-none transition-all duration-300 ${
                    activeTab === 'profile'
                      ? 'text-white'
                      : 'text-black hover:text-amber-700 dark:text-white dark:hover:text-amber-400'
                  }`}
                  onClick={() => setActiveTab('profile')}
                >
                  Profile
                </button>
              </div>
            </div>

            {/* Tab Content */}
            <div className="relative h-[160px] overflow-hidden rounded-lg bg-white shadow-sm dark:bg-stone-800">
              <div
                className="flex h-full transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(${activeTab === 'specification' ? '0%' : '-100%'})` }}
              >
                {/* Specifications Tab */}
                <div className="w-full flex-shrink-0 py-3 px-4">
                  <div className="space-y-3 h-full">
                    {(product.length || product.breadth || product.height) && (
                      <>
                        {/* Centered DIMENSIONS header */}
                        <div className="text-center border-b border-stone-100 pb-3 dark:border-stone-700">
                          <span className="text-stone-600 dark:text-stone-400 font-medium">DIMENSIONS</span>
                        </div>
                        {/* Length row */}
                        <div className="flex justify-between">
                          <span className="text-stone-600 dark:text-stone-400">Length</span>
                          <span className="font-medium dark:text-white">{product.length} {product.lbh_unit}</span>
                        </div>
                        {/* Width row */}
                        <div className="flex justify-between">
                          <span className="text-stone-600 dark:text-stone-400">Width</span>
                          <span className="font-medium dark:text-white">{product.breadth} {product.lbh_unit}</span>
                        </div>
                        {/* Height row */}
                        <div className="flex justify-between">
                          <span className="text-stone-600 dark:text-stone-400">Height</span>
                          <span className="font-medium dark:text-white">{product.height} {product.lbh_unit}</span>
                        </div>
                      </>
                    )}
                  </div>
                </div>

                {/* Profile Tab */}
                <div className="w-full flex-shrink-0 py-3 px-4">
                  <div className="h-full">
                    {/* Profile content from backend */}
                    <div className="prose prose-stone max-w-none dark:prose-invert">
                      <div className="space-y-3 h-full">
                        <div className="flex justify-between border-b border-stone-100 pb-3 dark:border-stone-700">
                          <span className="text-stone-600 dark:text-stone-400">Brand</span>
                          <span className="font-medium dark:text-white">{product.brand_name || 'Marnois'}</span>
                        </div>
                        {product.specification && (
                          <div className="flex justify-between">
                            <span className="text-stone-600 dark:text-stone-400">Details</span>
                            <div 
                              className="font-medium dark:text-white text-left" 
                              style={{ 
                                maxWidth: '60%', 
                                maxHeight: '100px', 
                                overflowY: 'auto',
                                scrollbarWidth: 'thin',
                                paddingRight: '5px'
                              }}
                              dangerouslySetInnerHTML={{ __html: product.specification }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Related Products - Complete Your Space */}
        {relatedProducts.length > 0 && (
          <section className="bg-white py-16 dark:bg-stone-950">
            <div className="mx-auto max-w-6xl px-4">
              <h2 className="mb-12 text-center font-serif text-3xl font-light md:text-4xl dark:text-white">
                Complete Your Space
              </h2>

              <div className="relative overflow-hidden">
                <div 
                  className="flex gap-6 transition-transform duration-500 ease-in-out" 
                  style={{ transform: `translateX(-${relatedProductsIndex * (280 + 24)}px)` }}
                >
                  {relatedProducts.map((item, index) => (
                    <div
                      key={item.id}
                      className="w-[280px] flex-shrink-0 cursor-pointer transition-all duration-500 hover:-translate-y-2 hover:scale-105"
                    >
                                                              <Link to={`/product-luxury/${item.slug}`}>
                        <div className="group overflow-hidden rounded-lg bg-stone-100 dark:bg-stone-800">
                          <div className="relative aspect-square overflow-hidden">
                            <img
                              src={`${IMG_URL}/productimg/${item.image1}`}
                              alt={item.title}
                              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                            />
                          </div>
                          <div className="p-4">
                            <h3 className="font-serif text-lg dark:text-white">{item.title}</h3>
                            <p className="mt-1 font-light dark:text-white">₹{formatIndianPrice(item.disc_price)}</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>

                {/* Improved Carousel Controls */}
                <div className="absolute left-0 top-1/2 flex w-full -translate-y-1/2 justify-between px-4">
                  <button
                    className="rounded-full bg-white/80 p-2 shadow-md transition-all duration-300 hover:bg-white hover:shadow-lg dark:bg-stone-800/80"
                    onClick={() => setRelatedProductsIndex((prev) => Math.max(0, prev - 1))}
                  >
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                  <button
                    className="rounded-full bg-white/80 p-2 shadow-md transition-all duration-300 hover:bg-white hover:shadow-lg dark:bg-stone-800/80"
                    onClick={() =>
                      setRelatedProductsIndex((prev) => Math.min(relatedProducts.length - 4, prev + 1))
                    }
                  >
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </div>

                {/* Carousel Indicators */}
                <div className="mt-8 flex justify-center">
                  <div className="flex gap-2">
                    {Array.from({ length: Math.max(1, relatedProducts.length - 3) }).map((_, index) => (
                      <button
                        key={index}
                        className={`h-2 w-2 rounded-full ${
                          relatedProductsIndex === index
                            ? "bg-amber-700 dark:bg-amber-500"
                            : "bg-stone-300 dark:bg-stone-700"
                        }`}
                        onClick={() => setRelatedProductsIndex(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Sticky Add to Cart Bar (Mobile) */}
        {isMobile && showStickyBar && (
          <div 
            className="fixed bottom-0 left-0 z-50 w-full bg-white p-4 shadow-lg transition-transform duration-300 dark:bg-stone-900"
            style={{
              transform: showStickyBar ? 'translateY(0)' : 'translateY(100px)',
            }}
          >
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium dark:text-white">{product.title}</h3>
                <p className="text-lg font-light dark:text-white">₹{formatIndianPrice(product.disc_price)}</p>
              </div>
              <button
                className="rounded-full bg-amber-700 px-6 py-2 text-white transition-colors duration-300 hover:bg-amber-800 disabled:opacity-50 dark:bg-amber-600 dark:hover:bg-amber-700"
                disabled={product.stock <= 0 || product.stock === reserveStock}
                onClick={() => handleAddToCart(product)}
              >
                {product.stock > 0 && product.stock !== reserveStock ? "Add to Cart" : "Notify Me"}
              </button>
            </div>
          </div>
        )}

        {/* Floating Wishlist Button - matching DetailPage logic */}
        {showStickyBar && !isMobile && (
          <>
            {!Cookies.get('custuserid') ? (
              <button
                className="fixed bottom-8 right-8 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white text-stone-800 shadow-lg transition-all duration-300 hover:scale-110 hover:bg-stone-100 dark:bg-stone-800 dark:text-white dark:hover:bg-stone-700"
                onClick={() => handleToggle()}
                style={{
                  transform: showStickyBar ? 'scale(1)' : 'scale(0)',
                  opacity: showStickyBar ? 1 : 0
                }}
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </button>
            ) : (
              <button
                className="fixed bottom-8 right-8 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-white text-stone-800 shadow-lg transition-all duration-300 hover:scale-110 hover:bg-stone-100 dark:bg-stone-800 dark:text-white dark:hover:bg-stone-700"
                onClick={() => {
                  addWishList(product.id);
                  wishify();
                }}
                style={{
                  transform: showStickyBar ? 'scale(1)' : 'scale(0)',
                  opacity: showStickyBar ? 1 : 0
                }}
              >
                <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </button>
            )}
          </>
        )}

        {/* Price Request Dialog */}
        {isPriceRequestOpen && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 p-4">
            <div className="w-full max-w-2xl min-h-[350px] overflow-auto rounded-lg bg-white shadow-xl dark:bg-stone-900 flex flex-col justify-center transform scale-90">
              <div className="bg-gradient-to-r from-amber-700 to-amber-900 p-6 text-white dark:from-amber-800 dark:to-amber-950">
                <h2 className="text-2xl font-serif font-light">Price Request</h2>
                <p className="text-amber-100">{product.title}</p>
              </div>

              <form onSubmit={handlePriceRequestSubmit} className="p-6">
                <div className="space-y-4">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Full Name</label>
                      <input
                        type="text"
                        name="name"
                        value={priceRequestForm.name}
                        onChange={handlePriceRequestChange}
                        placeholder="Example Singh :p"
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        required
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={priceRequestForm.phone}
                        onChange={handlePriceRequestChange}
                        placeholder="+91 9876***210"
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        required
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Email</label>
                    <input
                      type="email"
                      name="email"
                      value={priceRequestForm.email}
                      onChange={handlePriceRequestChange}
                      placeholder="your@email.com"
                      className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                      required
                    />
                  </div>

                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">City</label>
                      <input
                        type="text"
                        name="city"
                        value={priceRequestForm.city}
                        onChange={handlePriceRequestChange}
                        placeholder="Mumbai"
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        required
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Postal/Zip Code</label>
                      <input
                        type="text"
                        name="pincode"
                        value={priceRequestForm.pincode}
                        onChange={handlePriceRequestChange}
                        placeholder="10001"
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">State/Province</label>
                      <input
                        type="text"
                        name="state"
                        value={priceRequestForm.state}
                        onChange={handlePriceRequestChange}
                        placeholder="New Delhi"
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        required
                      />
                    </div>

                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={priceRequestForm.country}
                        onChange={handlePriceRequestChange}
                        placeholder="India"
                        className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                        required
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Your Customization Query</label>
                    <textarea
                      name="remarks"
                      value={priceRequestForm.remarks}
                      onChange={handlePriceRequestChange}
                      rows={4}
                      placeholder="Please let us know your customization thoughts..."
                      className="block w-full rounded-md border border-gray-300 px-3 py-2 focus:border-amber-500 focus:outline-none focus:ring-amber-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                      required
                    />
                  </div>
                </div>

                <div className="mt-6 flex justify-end space-x-3">
                  <button
                    type="button"
                    onClick={() => setIsPriceRequestOpen(false)}
                    className="rounded-full border border-stone-300 px-4 py-2 text-gray-700 transition-colors duration-300 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="rounded-full bg-amber-700 px-4 py-2 text-white transition-colors duration-300 hover:bg-amber-800 dark:bg-amber-600 dark:hover:bg-amber-700"
                  >
                    Submit Request
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Login Modal - matching DetailPage exactly */}
        {open && <LoginForm setOpen={setOpen} open={open} />}
      </div>
    </>
  );
};

export default ProductDetailLuxury; 